/**
 * @fileoverview NoTest component that displays a message when no tests are found.
 * It includes an icon, a caption, and a description.
 *
 * @example
 * // Usage in a component:
 * import { NoTest } from './NoTest'
 *
 * function TestNoTest() {
 *   return <NoTest />
 * }
 */

import { useTranslation } from 'react-i18next'
import config from '../config'
import { useAssets } from '../hooks/useAssets'
import css from './NoTest.module.css'
import { Text } from './typography/Typography'

/**
 * @function NoTest
 * @description Displays a message when no tests are found.
 * @returns {JSX.Element | null} The rendered NoTest component or null if assets are not loaded.
 */
export function NoTest() {
    const { t } = useTranslation()
    const areAssetsLoaded = useAssets()

    if (!areAssetsLoaded) {
        return null
    }

    return (
        <div className={css.container}>
            <img
                width="32"
                height="32"
                src={config.s3.getStaticURL('no-test.svg')}
                alt="no test available"
            />

            <Text className={css.caption}>{t('screens.noTest.caption')}</Text>

            <Text className={css.description}>{t('screens.noTest.description')}</Text>
        </div>
    )
}
